import { RootState } from "common/reducers";
import { AppMessageMetadataRecord, AppMessageUiStateRecord, model } from "common/reducers/appMessage.reducer";
import { AppMessageRecipientRecord } from "common/records/AppMessage";
import { ids } from "common/selectors/idsManagement.selectors";
import { IdType, Nullable } from "common/types";
import { List, Map } from "immutable";
import { createSelector } from "reselect";

const EMPTY_METADATA = AppMessageMetadataRecord();
const EMPTY_MESSAGES = List<AppMessageRecipientRecord>();

const EMPTY_BY_ID = Map<IdType, AppMessageRecipientRecord>();

const uiState = (state: RootState): Nullable<ReturnType<typeof AppMessageUiStateRecord>> =>
  state.getIn([model, "uiState"]);
const byId = (state: RootState): Map<IdType, AppMessageRecipientRecord> => state.getIn([model, "byId"]) ?? EMPTY_BY_ID;

export const appMessage = (state: RootState, props: { messageId: string }): Nullable<AppMessageRecipientRecord> =>
  state.getIn([model, "byId", props.messageId]);

export const appMessageMetadata: (state: RootState) => typeof EMPTY_METADATA = createSelector(
  [(state: RootState) => state.getIn([model, "metadata"])],
  (metadata) => metadata ?? EMPTY_METADATA,
);

export const unreadTotal: (state: RootState) => number = createSelector(
  [appMessageMetadata],
  (metadata) => metadata.get("unread_total") || 0,
);

export const messagesLoadFailed: (state: RootState) => boolean = createSelector([uiState], (state) =>
  state ? state.get("loadFailed") : false,
);

export const appMessagesForPage: (state: RootState) => List<AppMessageRecipientRecord> = createSelector(
  [(state: RootState) => ids(state, { modelName: model }), byId],
  (messageIds, messagesById) =>
    messageIds.isEmpty()
      ? EMPTY_MESSAGES
      : messageIds
          .map((id) => messagesById.get(id))
          .filter((message): message is AppMessageRecipientRecord => Boolean(message)),
);
